import { render, staticRenderFns } from "./dataanalysis.vue?vue&type=template&id=29698e50&scoped=true"
import script from "./dataanalysis.vue?vue&type=script&lang=js"
export * from "./dataanalysis.vue?vue&type=script&lang=js"
import style0 from "./dataanalysis.vue?vue&type=style&index=0&id=29698e50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29698e50",
  null
  
)

export default component.exports